<script setup lang="ts">
const {
  public: {baseUrl},
} = useRuntimeConfig()

const {fetch} = useImpressum()

const {data: initialData} = await useAsyncData('impressum', () => fetch())
const {data: impressum} = useLivePreview({initialData: initialData.value, depth: 1})

if (!impressum.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
  })
}

const meta = impressum.value?.meta

useSeoMeta({
  title: meta?.title || 'Impressum | Webamboos',
  description: meta?.description,
  ogUrl: `${baseUrl}/impressum`,
  ogTitle: meta?.ogTitle || meta?.title,
  ogDescription: meta?.ogDescription || meta?.description,
  ogImage: resolveMediaUrl(meta?.image),
  ogImageAlt: resolveMediaAlt(meta?.image),
})
</script>

<template>
  <Container class="screen-content flex-1 px-0 pb-32">
    <LayoutPageHeader :title="$t('header.page_titles.impressum')" />
    <div class="mx-auto max-w-xl px-8">
      <div class="prose !max-w-full prose-h2:text-lg prose-h2:!font-bold prose-p:text-gray-800 prose-a:no-underline">
        <RichText v-if="impressum?.content" :raw="impressum.content" />
      </div>
    </div>
  </Container>
</template>
